import { render, staticRenderFns } from "./RemoveFromCampaign.vue?vue&type=template&id=bc36be28&scoped=true&"
import script from "./RemoveFromCampaign.vue?vue&type=script&lang=js&"
export * from "./RemoveFromCampaign.vue?vue&type=script&lang=js&"
import style0 from "./RemoveFromCampaign.vue?vue&type=style&index=0&id=bc36be28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc36be28",
  null
  
)

export default component.exports